import React from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';

import { TASK_STATUS_COLORS } from './PlanTaskStatus.consts';
import { useTaskLocale } from '../../../../hooks';
import { TaskStatus } from '../../../../types';

interface PlanTaskStatusBarProps {
  status: TaskStatus;
}

const PlanTaskStatus = ({ status }: PlanTaskStatusBarProps) => {
  const { T } = useTaskLocale();

  const statusBarColor = TASK_STATUS_COLORS[status];
  const displayedStatus = T.translate(`STATUS.${status}`);

  return (
    <Flex alignItems="center" style={{ gap: '8px' }}>
      <Box width="3px" height="16px" backgroundColor={statusBarColor} />
      <div>{displayedStatus}</div>
    </Flex>
  );
};

export default PlanTaskStatus;
